import { useParams } from "react-router-dom";
import { PageTypes } from "../enums/pageTypes.ts";
import { usePageType } from "./usePageType";

export const useHomeUrl = () => {
  const { customerId, sport, organizationId, entityId } = useParams();
  const pageType = usePageType();

  if (customerId) {
    if (sport && organizationId) {
      switch (pageType) {
        case PageTypes.Admin:
          return `/${customerId}/${sport}/${organizationId}/admin`;
        case PageTypes.TeamManager:
          return entityId
            ? `/${customerId}/${sport}/${organizationId}/entities/${entityId}`
            : `/${customerId}/${sport}/${organizationId}/entities`;
      }
    }

    return `/${customerId}`;
  }

  return "/";
};
